import React, { useRef } from 'react'
import AwsConfig from '../../Config/AwsConfig'

const TfidbPersonMovieDragandDrop = props => {
  // props for this file from parent
  const {
    display,
    senddata,
    inputData,
    inputField1,
    // personnames,
    // sendsearchtrue,
    // sendtruevalue,
    // name,
    // editmode,
    // editpersonmode,
    // sendPersonEditmode,
    modeUrl,
    indication,
    setValueChanged,
  } = props
  // state varible for this file
  const dragItem = useRef()
  const dragOverItem = useRef()
  // function to trigger on click for edit mode
  //   const edit = (event, index) => {
  //     sendPersonEditmode(false)
  //     // sendtruevalue(`${name}_En`, true)
  //     sendsearchtrue(!true)
  //     const copyListItems = [...display]
  //     // const value = copyListItems.splice(index, 1)
  //     senddata(copyListItems)
  //   }

  const dragStart = (e, position) => {
    // in this function starting postion of  dragged item is calculated
    dragItem.current = position
  }

  const dragEnter = (e, position) => {
    // in this function ending postion of  dragged item is calculated
    dragOverItem.current = position
  }

  const drop = () => {
    // sendtruevalue(`${name}_En`, true)
    const copyListItems = [...display]
    const dragItemContent = copyListItems[dragItem.current]
    copyListItems.splice(dragItem.current, 1)
    copyListItems.splice(dragOverItem.current, 0, dragItemContent)
    dragItem.current = null
    dragOverItem.current = null
    // new array after drag and drop is sent to parent
    senddata(copyListItems)
  }

  // function to trigger when X button is clicked to delete name or value from array
  const deleteFunction = (event, index) => {
    // sendtruevalue(`${name}_En`, true)
    // items are spliced based on index
    const copyListItems = [...display]
    copyListItems.splice(index, 1)
    // new array after deletion is sent to parent
    const inputDataTemp = { ...inputData }
    inputDataTemp[inputField1] = copyListItems
    senddata(inputDataTemp)
    setValueChanged(true)
  }

  const indicator = modeUrl && indication

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid lightgray',
        ...indicator,
      }}
      className='rounded'
    >
      {display &&
        display.map((item, index) => (
          <div
            onDragStart={e => dragStart(e, index)}
            onDragEnter={e => dragEnter(e, index)}
            onDragEnd={drop}
            key={index}
            draggable
            style={{ marginBottom: '10px' }} // Adjust margin bottom as needed
          >
            <div
              style={{
                border: '1px solid black',
                borderRadius: '1rem',
                padding: '3px',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                width: 'fit-content',
                minHeight: '45px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
                // onClick={event => {
                //   if (item.isAnonymous) {
                //     if (editpersonmode === true) {
                //       edit(event, index)
                //     }
                //   }
                // }}
              >
                <div
                  style={{ marginRight: '10px' }} // Adjust margin right as needed
                >
                  {
                    <img
                      style={{
                        width: '2rem',
                        height: '2rem',
                        borderRadius: '50%',
                      }} // Adjust width, height, and border radius as needed
                      src={AwsConfig.movieCdnUrl + item.posterURL}
                      // alt={item.name_En}
                    />
                  }
                </div>
                <div style={{ flexGrow: 1 }}>
                  {' '}
                  {/* Allow the text to take remaining space */}
                  <span style={{ fontSize: '16px' }}>{item.title_En}</span>{' '}
                  {/* Adjust font size and weight as needed */}
                </div>
                {/* {item.isAnonymous ? (
                  <span
                    style={{
                      color: 'white',
                      backgroundColor: 'gray',
                      fontSize: '8px',
                      position: 'absolute',
                      top: '0px',
                      right: '35px',
                    }}
                  >
                    Anonymous
                  </span>
                ) : (
                  ''
                )} */}
              </div>
              <button
                type='button'
                style={{
                  borderRadius: '50%',
                  padding: '5px 5px',
                  marginLeft: '10px',
                  height: '20px',
                  width: '20px',
                }} // Adjust padding, margin left, and button size as needed
                onClick={event => deleteFunction(event, index)}
              >
                <span style={{ position: 'relative', bottom: '10px', right: '1px' }}>x</span>
              </button>
            </div>
          </div>
        ))}
    </div>
  )
}

export default TfidbPersonMovieDragandDrop
